import React, {useMemo, useRef, useEffect, useState} from 'react';
import {throttle, useWindowSize} from 'helpers';
import css from './dynamic-container.module.scss';

export function DynamicContainer({ collapsed, containerClassName, ...props }) {
  const [ mounted, setMounted ] = useState();
  const container = useRef();
  const inner = useRef();
  const [ state ] = useState({});
  state.collapsed = collapsed;

  const update = useMemo(() => throttle(() => {
    const value = state.collapsed ? 0 : inner.current.offsetHeight;
    if (value !== state.before) {
      const diff = value - parseInt(container.current.style.height || '0');
      container.current.classList.toggle('growing', diff > 0);
      container.current.classList.toggle('shrinking', diff < 0);
      container.current.style.height = value + 'px';
    }
    state.before = value;
  }, 20), []);

  useEffect(update, [ collapsed, useWindowSize() ]);

  useEffect(() => {
    setTimeout(() => requestAnimationFrame(() => setMounted(true)), 0);
    if (collapsed) {
      update();
    } else {
      const observer = new MutationObserver(update);
      observer.observe(inner.current, { childList: true, subtree: true, characterData: true });
      return () => observer.disconnect();
    }
  }, [ collapsed ]);

  return (
    <div className={css('container', containerClassName, {mounted})} ref={container}>
      <div {...props} ref={inner} />
    </div>
  );
}
